import { defineComponent as _defineComponent } from 'vue'
import {CanadaFOPHighInMetadata} from "@/models/NutritionLabels/CanadaFOPHighInMetadata";
import {Nutritions} from "@/models/Recipes/Nutritions";

type vFoPWarningProps = {
  nutritionAnalysis: Nutritions,
  referenceAmount: number,
  isShown?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vFoPWarning',
  props: {
    nutritionAnalysis: null,
    referenceAmount: null,
    isShown: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { nutritionAnalysis: Nutritions, referenceAmount: number, isShown: boolean };



return { __sfc: true,props, CanadaFOPHighInMetadata }
}

})